import { Component, OnInit } from '@angular/core';
import { GoogleTagManagerService } from 'src/app/services/google-tag-manager.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-btn-whatsapp',
  templateUrl: './btn-whatsapp.component.html',
  styleUrls: ['./btn-whatsapp.component.scss']
})
export class BtnWhatsappComponent implements OnInit {

  constructor(private gtmService: GoogleTagManagerService) { }

  textWhatsApp: string | undefined;

  ngOnInit(): void {
    this.textWhatsApp=environment.contacts.textWhatsappButton
  }

  async onWhatsAppButtonClick() {
    this.gtmService.push({
      event: 'contactWhatsapp'
    });
    
    window.open(environment.contacts.whatsApp, '_blank');
  }

}
